import React, { useState, useEffect } from 'react';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';
import { Helmet } from 'react-helmet';
import api from '../../services/api';
import { Spin } from 'antd';

const PrivacyPolicy = () => {
  const [policy, setPolicy] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPrivacyPolicy();
  }, []);

  const fetchPrivacyPolicy = async () => {
    try {
      const response = await api.get('/privacy');
    if (response.data.success && response.data.data) {
      setPolicy(response.data.data);
    }
    
   
    } catch (error) {
      console.error('Error fetching privacy policy:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="home-page">
      <Helmet>
        <title>Privacy Policy - Startup Business Partners</title>
      </Helmet>
      
      <Navbar />
          <section className="breadcrumb_area breadcrumb2 bgimage biz_overlay">
        <div className="bg_image_holder" style={{backgroundImage: 'url("img/breadbg.jpg")', opacity: 1, backgroundImage: 'linear-gradient(to right, #413AA4, rgb(16 139 255))'}}>
          <img src="img/breadbg.jpg" alt="img/breadbg.jpg" />
        </div>
        <div className="container content_above">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcrumb_wrapper d-flex flex-column align-items-center">
                <h4 className="page_title">Privacy Policy</h4>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb m-bottom-30">
                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                    <li className="breadcrumb-item active" aria-current="page">Privacy Policy</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="sectionbg p-top-100 p-bottom-110">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="mb-5">
                <div className="divider divider-simple text-center">
                  <h3>Privacy Policy</h3>
                </div>
              </div>
            </div>
          </div>
          
          <div className="row">
            <div className="col-lg-12">
              {loading ? (
                <div className="text-center">
                  <Spin size="large" />
                </div>
              ) : (
                <div className="card">
                  <div className="card-body">
                    {policy ? (
                      <>
                        {/* <h4 className="mb-4">{policy.title}</h4> */}
                        <div dangerouslySetInnerHTML={{ __html: policy.content }} />
                      </>
                    ) : (
                      <p>No privacy policy found.</p>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;